/* @flow */
import type { ReduxState, Action, Fetchable, Production } from 'types';

// ===========================
//   STATE TYPE
// ===========================
type ProductionsState = {
  productions: Fetchable<Production[]>,
  production: Fetchable<Production>,
  selectedProductionId?: ?number,
};

// ===========================
//   INITIAL STATE
// ===========================
const initialState: ProductionsState = {
  productions: { fetching: false },
  production: { fetching: false },
};

// ===========================
//   REDUCER
// ===========================
export default (state: ProductionsState = initialState, action: Action): ProductionsState => {
  switch (action.type) {
    // PRODUCTION_LIST
    case 'FETCH_PRODUCTION_LIST_REQUEST': {
      return {
        ...state,
        productions: { fetching: true },
      };
    }
    case 'FETCH_PRODUCTION_LIST_SUCCESS': {
      const data = action.payload;
      return {
        ...state,
        productions: { fetching: false, data },
      };
    }
    case 'FETCH_PRODUCTION_LIST_FAILURE': {
      const error = action.payload;
      return {
        ...state,
        productions: { fetching: false, error },
      };
    }
    // PRODUCTION
    case 'CREATE_PRODUCTION': {
      return {
        ...state,
        selectedProductionId: null,
        production: { fetching: false },
      };
    }
    case 'DELETE_PRODUCTION_REQUEST':
    case 'SAVE_PRODUCTION_REQUEST': {
      return {
        ...state,
        production: { fetching: true, data: state.production.data },
      };
    }
    case 'FETCH_PRODUCTION_REQUEST': {
      return {
        ...state,
        production: { fetching: true },
      };
    }
    case 'DELETE_PRODUCTION_FAILURE':
    case 'SAVE_PRODUCTION_FAILURE':
    case 'FETCH_PRODUCTION_FAILURE': {
      const error = action.payload;
      return {
        ...state,
        production: { fetching: false, error },
      };
    }
    case 'FETCH_PRODUCTION_SUCCESS': {
      const data = action.payload;
      return {
        ...state,
        selectedProductionId: data.id,
        production: { fetching: false, data },
      };
    }
    case 'SAVE_PRODUCTION_SUCCESS': {
      const data = action.payload;
      return {
        ...state,
        production: { fetching: false, data },
      };
    }
    case 'DELETE_PRODUCTION_SUCCESS': {
      return state;
    }
    case 'LOGOUT_SUCCESS':
      return initialState;
    default: {
      return state;
    }
  }
};

// ===========================
//   SELECTORS
// ===========================

export const getProductions = (state: ReduxState): Fetchable<Production[]> => {
  return state.productions.productions;
};

export const getSelectedProductionId = (state: ReduxState): ?number | void => {
  return state.productions.selectedProductionId;
};

export const getProduction = (state: ReduxState): Fetchable<Production> => {
  return state.productions.production;
};
